// Tiny observable for the full-screen wellness check-in confirm. The push-tap
// handler (RootNavigator) sets the pending check-in when a wellness_check_now /
// wellness_checkin push is OPENED (tapped, not the lock-screen "I'm OK" action,
// which acks silently); WellnessCheckInSheet — mounted once, globally —
// subscribes and presents. Kept out of Redux: transient UI, single consumer.
// Mirrors voiceApprovalStore.
export type PendingWellnessCheckIn = {
  projectId: string;
  accountId: string;
  cognitoId: string;
};

let _pending: PendingWellnessCheckIn | null = null;
const listeners = new Set<(p: PendingWellnessCheckIn | null) => void>();

export function showWellnessCheckIn(p: PendingWellnessCheckIn): void {
  _pending = p;
  listeners.forEach((l) => l(_pending));
}

export function clearWellnessCheckIn(): void {
  _pending = null;
  listeners.forEach((l) => l(null));
}

export function getWellnessCheckIn(): PendingWellnessCheckIn | null {
  return _pending;
}

export function subscribeWellnessCheckIn(l: (p: PendingWellnessCheckIn | null) => void): () => void {
  listeners.add(l);
  // Replay the current value immediately: a push tapped while signed out sets
  // _pending BEFORE the sheet mounts (it's gated on `authorized`), and without
  // replay the post-login subscription would never learn about it.
  if (_pending) l(_pending);
  return () => {
    listeners.delete(l);
  };
}
